export * from './bds-erpc-origin.module';
